import * as models from 'src/models';
import useLocaleConfig from './useLocaleConfig';

const useLocale = (): models.locale.types.Locale => {
  const localeConfig = useLocaleConfig();
  return localeConfig.locale;
};

export default useLocale;
